export const initialState = {
  actionProcessing: false,
  limits: {
    digsport: null,
    slots: null,
    liveCasino: null,
  }
};
